import {
  useEditEngineeringJudgementMutation,
  useGetEjLogMetadataQuery,
  useGetEngineeringJudgementsQuery,
} from '../../../../../../../../schema'
import { createStrictContext } from '../../../../../../../../utils/createContext'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from '../../../../../../../../utils/defaults'
import { useGlobalState } from '../../../../../../../../context/GlobalStateContext'
import { EJLogContext, EngineeringJudgement } from './types'
import { useOptions } from '../../../../../../../../components/CIMSSelect/hooks/useOptions'
import { simpleEditNotification } from '../../../../../../../../hooks/notificationHandler'
import { useCIMSModalValues } from '../../../../../../../../components/CIMSModal/hooks/useCIMSModal'
import { WithPayItemGlobalId } from '../../../../../../../../components/CIMSTable/components/HeaderActionButtons/types'

const { Provider, useContextFn } =
  createStrictContext<EJLogContext>('EJLogContext')

export const useEJLogContext = useContextFn

export const EJLogProvider: React.FC<WithPayItemGlobalId> = ({
  payItemGlobalId,
  children,
}) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const {
    refetch,
    loading: fetching,
    data: ejData,
  } = useGetEngineeringJudgementsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      projectId: projectId!,
      engineeringJudgementListInput: {
        projectId: {
          equals: projectId,
        },
      },
    },
    skip: !projectId,
  })
  const metadata = useGetEjLogMetadataQuery({
    ...DefaultQueryHookOptions,
    variables: { globalId: projectId! },
    skip: !projectId,
  })
  const [edit, { loading: editLoading }] = useEditEngineeringJudgementMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editEngineeringJudgement: {
        judgement: { formattedNumber },
      },
    }) => simpleEditNotification(formattedNumber),
  })
  const draftSubmitModal = useCIMSModalValues<EngineeringJudgement>()
  const editModal = useCIMSModalValues<EngineeringJudgement>()
  const revertModal = useCIMSModalValues<EngineeringJudgement>()

  return (
    <Provider
      value={{
        refetch,
        records: ejData?.engineeringJudgements?.records ?? [],
        metadata: { ...metadata, ...metadata.data?.project },
        fetching,
        payItemGlobalId,
        typeOptions: useOptions({
          items: metadata.data?.project?.ejTypes,
          value: 'id',
          label: 'name',
          sort: 'name',
          tooltip: 'allowanceDescription',
        }),
        edit,
        editLoading,
        draftSubmitModal,
        editModal,
        revertModal,
      }}
    >
      {children}
    </Provider>
  )
}
